/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSync = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path
          strokeLinejoin="round"
          d="M1 19.864v-4.243h4.243M23.121 4v4.243H18.88"
        />
        <path d="M22.31 16.001C20.71 20.098 16.724 23 12.06 23c-4.663 0-8.649-2.902-10.25-6.999M1.81 8c1.6-4.097 5.587-7 10.25-7 4.665 0 8.65 2.903 10.25 7" />
      </g>
    </svg>
  ),
);
